(function() {
  function applyCartFix() {
    if (!window.Alpine || !window.Alpine.store('xMiniCart')) return;
    
    window.Alpine.store('xMiniCart').type = 'drawer';
    
    // Use Alpine effect to reactively sync cart open state to body attribute
    window.Alpine.effect(function() {
      var isOpen = window.Alpine.store('xMiniCart').open;
      if (isOpen) {
        document.body.setAttribute('data-cart-open', '');
      } else {
        document.body.removeAttribute('data-cart-open');
      }
    });
  }
  
  document.addEventListener('alpine:initialized', applyCartFix);
  if (window.Alpine && window.Alpine.store('xMiniCart')) {
    applyCartFix();
  }
})();
